import blackPantherImg from "../images/disney-black-panther.png";
import eatDefaultImg from "../images/eat-default.png";
import hotDealsDefaultImg from "../images/hotDeals-default.png";
import playDefaultImg from "../images/play-default.png";
import shopDefaultImg from "../images/shop-default.png";
import { t } from "@lingui/core/macro";
import { categoryKeys, ROUTES } from "@Src/constants";

export const eatDefaultPick = () => {
  return {
    category_key: categoryKeys.EAT,
    mainText: t`Save on Dining near you!`,
    subText: t`View Deals`,
    img: eatDefaultImg,
  };
};

export const playDefaultPick = () => {
  return {
    category_key: categoryKeys.PLAY,
    mainText: t`Save on Entertainment`,
    subText: t`View Deals`,
    img: playDefaultImg,
  };
};

export const shopDefaultPick = () => {
  return {
    category_key: categoryKeys.SHOP,
    mainText: t`Save on Shopping`,
    subText: t`View Deals`,
    img: shopDefaultImg,
  };
};

export const hotDealsDefaultPick = () => {
  return {
    store_key: "18938071",
    mainText: t`Shop Today's Best Deals`,
    subText: "Apple.com",
    img: hotDealsDefaultImg,
  };
};

export const themeParksDefaultPick = () => {
  return {
    category_key: categoryKeys.THEMEPARKS,
    mainText: t`Save up to $25`,
    subText: "Disneyland Resort",
    img: blackPantherImg,
    route: ROUTES.PARKS_PATH,
  };
};
